export default __webpack_public_path__ + "static/media/docx.9dff1f05.svg";